import { Component, OnInit } from '@angular/core';
import { IBlog } from 'src/app/shared/interfaces/blog';
import { FakeDataService } from 'src/app/shared/mock/fake-data.service';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrl: './blog.component.css'
})
export class BlogComponent implements OnInit{

  searchTitle: string = '';
  blogList: IBlog;


  first: number = 0 ;
  rows: number =  30;
  pageSize = 30;  
  currentpage = 1;
  collectionSize: number = 0;

  constructor(
    public apiService: ApiService,
    private fakeDataService: FakeDataService) {}

  ngOnInit(): void {
    this.getBlogList(1);    
  }


  getBlogList(page) {
    // this.fakeDataService.getBlogs().subscribe((res: any) => {
    //   this.blogList = res;
    // })

    const params = {
      title: this.searchTitle,
      PageIndex: page,
      pageSize: this.pageSize
    }

    this.apiService.apiCall('get', '/api/SitesBlog/GetAllSiteBlogs', {} , params).subscribe((res: any) => {
      console.log(res);
      this.blogList = res.body.model;
      this.collectionSize = res.body.collectionSize;
    })
  }

}
